import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import authService from "../services/authService";
import menuVisibilityService from "../services/menuVisibilityService";
import { AppAlert, AppSpinner } from "./ui";

const ProtectedRoute = ({ children, menuKey = null }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [menuAllowed, setMenuAllowed] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);
      setMenuAllowed(null);

      if (!authService.isAuthenticated()) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        const isValid = await authService.validateToken();
        setIsAuthenticated(isValid);
        if (isValid) {
          authService.startSessionKeepAlive();
          try {
            await menuVisibilityService.load();
          } catch (err) {
            console.error('Erreur chargement visibilité menus:', err);
          }
          const allowed = menuKey
            ? menuVisibilityService.canSee(menuKey)
            : menuVisibilityService.canAccessPath(location.pathname);
          setMenuAllowed(allowed);
        } else {
          setMenuAllowed(false);
        }
      } catch (error) {
        console.error('Erreur lors de la validation du token:', error);
        setIsAuthenticated(false);
        setMenuAllowed(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();

    return () => authService.stopSessionKeepAlive();
  }, [location.pathname, menuKey]);

  if (isLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <AppSpinner centered={false} className="mb-3" />
          <p className="text-muted">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (menuAllowed === false) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <AppAlert variant="warning">
            <i className="ri-error-warning-line me-2"></i>
            <strong>Accès refusé</strong>
            <p className="mb-0">Cette section n'est pas accessible avec votre rôle.</p>
          </AppAlert>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
